import {useAuthUserStore} from "@/stores/auth";

export default {
    ask(academyUuid, question) {

        return useAuthUserStore().getApiClient.post('/academy/user/kb-chatbot/ask', {
            academy_uuid: academyUuid,
            question: question
        })
    }
}
